class SliderComponent extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slider-track]');
    this.prevBtn = this.querySelector('[data-slider-prev]');
    this.nextBtn = this.querySelector('[data-slider-next]');
    this.dotsWrap = this.querySelector('[data-slider-dots]');
    if (!this.track) return;

    this.slides = Array.from(this.track.children);
    this.index = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.interval = parseInt(this.dataset.interval, 10) || 5000;

    this.buildDots();
    this.bindEvents();
    if (this.autoplay && this.slides.length > 1) this.startAutoplay();
  }

  buildDots() {
    if (!this.dotsWrap) return;
    this.slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Slayt ' + (i + 1));
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsWrap.appendChild(dot);
    });
  }

  bindEvents() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.index - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.index + 1));
    this.track.addEventListener('mouseenter', () => this.stopAutoplay());
    this.track.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });
  }

  goTo(i) {
    const count = this.slides.length;
    this.index = (i + count) % count;
    const slide = this.slides[this.index];
    this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    if (this.dotsWrap) {
      Array.from(this.dotsWrap.children).forEach((dot, idx) => {
        dot.classList.toggle('is-active', idx === this.index);
      });
    }
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', SliderComponent);
}
